var map = {
	"./4me.png": "y6DN",
	"./AppDynamics.png": "w1Gq",
	"./AutoMox.png": "Ekgr",
	"./BambooHR.png": "S9ar",
	"./Box.png": "8K1j",
	"./Cisco-Meraki.png": "aNbh",
	"./Cisco-Webex.png": "TgZf",
	"./Dropbox.png": "p0Xk",
	"./Freshworks.png": "TVSm",
	"./GSuite.png": "l3x+",
	"./GitHub.png": "Ecnz",
	"./GitLab.png": "3nv4",
	"./Humanity.png": "rAK7",
	"./Jira.png": "XAxZ",
	"./Mavenlink.png": "tIo6",
	"./MondayCom.png": "6J78",
	"./Office365.png": "33On",
	"./Pipedrive.png": "Oz3W",
	"./SailPoint-IDN.png": "Q7Ap",
	"./Salesforce.png": "iBxb",
	"./ServiceNow.png": "11aq",
	"./Slack.png": "7GZV",
	"./TextMagic.png": "i7uM",
	"./WordPress.png": "RUve",
	"./Zendesk.png": "Iyz6",
	"./Zoho.png": "WvkE",
	"./Zoom.png": "aMbs",
	"./aws.png": "/uLL",
	"./sigmacomputing.png": "FPDm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6yU0";